import { useSelector } from "react-redux"
import { ReduxState } from "model/state"
import { getRole, getIsSuperuser } from "helpers/permissions/roles"

export function useUserRole(): string {
  return useSelector((state: ReduxState) => getRole(state))
}

export function useIsSuperuser(): boolean {
  return useSelector((state: ReduxState) => getIsSuperuser(state))
}
